import { getTheme, IButtonStyles } from '@fluentui/react';

export const getToggleStyles = (color: string | undefined) => {
  const theme = getTheme();
  const getBackgroundColor = () => {
    switch (color) {
      case 'YELLOW':
        return theme.palette.yellow;
      case 'RED':
        return theme.palette.red;
      case 'GREEN':
        return theme.palette.greenLight;
      case 'CYAN':
        return theme.palette.blueLight;
      case 'MAGENTA':
        return theme.palette.magentaLight;
      case 'DISABLED':
        return theme.palette.neutralTertiaryAlt;
      default:
        return theme.palette.themePrimary;
    }
  };
  const getColor = () => {
    switch (color) {
      case 'YELLOW':
        return '#423000';
      case 'RED':
        return 'white';
      case 'GREEN':
        return theme.palette.greenDark;
      case 'CYAN':
        return theme.palette.themeDarker;
      case 'MAGENTA':
        return 'white';
      default:
        return 'white';
    }
  };
  const getFocusColor = () => {
    switch (color) {
      case 'YELLOW':
        return theme.palette.yellowDark;
      case 'RED':
        return theme.palette.redDark;
      case 'GREEN':
        return theme.palette.green;
      case 'CYAN':
        return '#05aefc';
      case 'MAGENTA':
        return theme.palette.magenta;
      default:
        return theme.palette.themeDark;
    }
  };

  const styles: IButtonStyles = {
    rootPressed: {
      borderColor: getFocusColor(),
      background: getFocusColor(),
    },
    rootHovered: {
      borderColor: getFocusColor(),
      background: getFocusColor(),
    },
    iconHovered: {
      color: theme.palette.white,
    },
    root: [
      {
        background: getBackgroundColor(),
        borderColor: getBackgroundColor(),
        color: getColor(),
      },
    ],
  };

  return styles;
};

const getButtonStylesCustom = (color: string): IButtonStyles => {
  const theme = getTheme();

  const baseRoot: IButtonStyles['root'] = {
    borderRadius: 5,
    height: 30,
    minWidth: 100, 
    padding: '10px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: 'white',
  };

  const baseStyles: IButtonStyles = {
    root: baseRoot,
    label: {
      padding: 0,
      fontWeight: 500,
    },
  };

  const colorMap: Record<string, string> = {
    GREEN: theme.palette.green,
    RED: theme.palette.red,
    BLUE: theme.palette.themePrimary,
    YELLOW: theme.palette.yellow,
    MAGENTA: theme.palette.magenta,
  };

  const bgColor = colorMap[color];

  return {
    ...baseStyles,
    root: {
      ...baseRoot,
      backgroundColor: bgColor,
    },
  };
};

export default getButtonStylesCustom;


